/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useState, useCallback } from 'react';
import '../../_chunks/dep-2acfafca.js';

var useRotate = function useRotate() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    rotateZ = _useState2[0],
    setRotateZ = _useState2[1];
  var onRotate = useCallback(function (ROTATE_COUNT) {
    setRotateZ(function (rotateZ2) {
      return rotateZ2 + ROTATE_COUNT;
    });
  }, []);
  var onResetRotate = useCallback(function () {
    return setRotateZ(0);
  }, []);
  return {
    rotateZ: rotateZ,
    onResetRotate: onResetRotate,
    onRotate: onRotate
  };
};

export { useRotate as default };
//# sourceMappingURL=useRotate.js.map
